import type { TFunction } from '@mint-lib/i18n';

import { IOErrorCodes, modalContentMap } from '../constants/insertionOrder.jsx';
import {
  IOStatuses,
  type GetModalContent,
  type IOStatusChip,
} from '../types/insertionOrder.js';

export const getModalContent = (props: GetModalContent) => {
  const getContent =
    modalContentMap[props.type as keyof typeof modalContentMap] ||
    modalContentMap.default;

  return getContent(props);
};

export const getInsertionOrderErrorMessages = (t: TFunction) => ({
  [IOErrorCodes.NO_MEDIA_ROWS]: t('No media rows found. Please try again'),
  [IOErrorCodes.BUYING_PLAN_NOT_FOUND]: t(
    'Buying plan not found. Please try again',
  ),
  [IOErrorCodes.IO_NOT_FOUND]: t('Insertion order not found. Please try again'),
  [IOErrorCodes.MISSED_MEDIA_ROWS]: t('Missed media rows'),
  default: t('Sorry, something went wrong. Please try again later'),
});

export const getMapOrderStatusToChip = (
  t: TFunction,
): Record<Partial<IOStatuses>, IOStatusChip> => ({
  [IOStatuses.UNSENT]: {
    label: t('Unsent'),
    tooltip: t('Either never sent or modified after being sent.'),
    color: 'info',
  },
  [IOStatuses.MISSING_DATA]: {
    label: t('Mandatory Data Missing'),
    tooltip: t(
      'Net media budget, start and end dates, price type and price value are mandatory',
    ),
    color: 'warning',
  },
  [IOStatuses.SENT]: {
    label: t('Sent'),
    tooltip: t('Already sent'),
    color: 'royal', // TODO: ask proper color for a status
  },
  [IOStatuses.DECLINED]: {
    label: t('Declined'),
    tooltip: t('Declined by the vendor'),
    color: 'error',
  },
  [IOStatuses.BOOKED]: {
    label: t('Booked'),
    tooltip: t('Confirmed and booked with the vendor'),
    color: 'success',
  },
});
